import React, { useEffect, useState, useRef } from "react";
import * as styles from "./event.css";
import sobaImage from "../../../../assets/Event/menusoba2.jpg";
import dogImage from "../../../../assets/Event/menudog.jpg";

export const Event: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div className={styles.container} id="event">
      <div className={styles.contentWrapper}>
        <div
          ref={ref}
          className={`${styles.content} ${isVisible ? styles.animate : ""}`}
        >
          <div className={styles.specialEventSection}>


            <div className={styles.eventSection}>
            <div className={styles.textContent}>
              <h2 className={styles.title}>EVENT</h2>
              <p className={styles.japaneseTitle}>特別なイベントも開催しています</p>

              <div className={styles.eventItem}>
              <div className={styles.eventImageWrapper}>
                <img src={sobaImage} alt="蕎麦の日" className={styles.eventImage} />
              </div>
              <div className={styles.textContent}>
                <h3 className={styles.title}>蕎麦の日</h3>
                <p className={styles.description}>
                  月に数回、北海道産蕎麦粉を使用し外二で打った本格手打ち蕎麦をご提供しております。
                  丁寧に打ち上げた蕎麦と鰹出汁と返しも拘ったつゆをお楽しみいただけます。蕎麦の付け合わせにはその時々で
                  麹を使ったお菜の小鉢と小丼、お漬物もご用意しております。
                </p>
              </div>
            </div>

            <div className={styles.eventItemReverse}>
              <div className={styles.eventImageWrapperReverse}>
                <img src={dogImage} alt="犬の日" className={styles.eventImage} />
              </div>
              <div className={styles.textContent}>
                <h3 className={styles.title}>犬の日</h3>
                <p className={styles.description}>
                  月に1回、大切な家族の一員であるわんちゃんと一緒にカフェでお食事をお楽しみいただける特別な日を設けております。
                  ペット連れでカフェランチをご堪能いただき、愛犬と素敵なひとときをお過ごしください。
                </p>
              </div>
            </div>

              <p className={styles.description}>
                新しいイベント情報はInstagramでチェックできます。
              </p>
            </div>
            <div className={styles.instagramWrapper}>
              <iframe
                className={styles.instagramFrame}
                src="https://www.instagram.com/kitchen_muku/embed"
                frameBorder="0"
                scrolling="no"
              />
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 